import React from 'react';
import '../../styles/common/latte-components.css';

const FileUpload = ({ file, onChange, onRemove, accept = ".pdf,.docx" }) => {
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // 파일 확장자 체크
      const fileExt = selectedFile.name.split('.').pop().toLowerCase();
      const allowedExtensions = ['pdf', 'docx'];
      
      if (!allowedExtensions.includes(fileExt)) {
        alert('PDF 또는 DOCX 파일만 업로드할 수 있습니다');
        e.target.value = ''; // input 초기화
        return;
      }
      
      onChange(selectedFile);
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div className="file-upload-container">
      {!file ? (
        <label className="file-upload-label">
          <input
            type="file"
            onChange={handleFileChange}
            accept={accept}
            className="file-upload-input"
          />
          <div className="file-upload-content">
            <svg className="file-upload-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
            </svg>
            <p className="file-upload-text">클릭하여 파일을 선택하세요</p>
            <p className="file-upload-hint">PDF, DOCX 파일만 지원됩니다</p>
          </div>
        </label>
      ) : (
        <div className="file-upload-preview">
          <div className="file-info">
            <svg className="file-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <div className="file-details">
              <p className="file-name">{file.name}</p>
              <p className="file-size">{formatFileSize(file.size)}</p>
            </div>
          </div>
          <button
            type="button"
            onClick={onRemove}
            className="file-remove-btn"
          >
            <svg className="file-remove-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default FileUpload;
